import moment from "moment";
import DailyAnalyticsModel from "../../../models/DailyAnalytics";
import firebase from "../../utils/firebase";

export const getDailyAnalytics = async () => {
  try {
    if (firebase.auth().currentUser?.uid) {
      const analyticsSnapshot = await firebase
        .firestore()
        .collection("dailyAnalytics")
        .orderBy("createdDate", "desc")
        .limit(1)
        .get();

      let selectedAnalytics = null;
      if (analyticsSnapshot) {
        analyticsSnapshot.forEach((eachAnalytics) => {
          selectedAnalytics = eachAnalytics.data();
        });
      }

      if (selectedAnalytics) {
        return selectedAnalytics;
      } else {
        return "No data";
      }
    } else {
      return "Unknown error, please contact developer at info@arusoil.com if this continues";
    }
  } catch (err) {
    return "Unknown error, please contact developer at info@arusoil.com if this continues";
  }
};

export const getWeeklyAnalytics = async () => {
  try {
    const selectedDateAnalytics: DailyAnalyticsModel[] = [];
    if (firebase.auth().currentUser?.uid) {
      const todayDate = moment().startOf("day").add(18, "hour");
      const currentDates: Date[] = [];
      currentDates.push(todayDate.toDate());
      for (let i = 1; i < 8; i++) {
        const subtractDate = moment(todayDate).subtract(i, "day");
        currentDates.push(subtractDate.toDate());
      }

      await Promise.all(
        currentDates.map(async (eachDate) => {
          const dateString = moment(eachDate).format("DMMMMYYYY-ha");
          const analyticsSnapshot = await firebase
            .firestore()
            .collection("dailyAnalytics")
            .where("dateStringWithTime", "==", dateString)
            .limit(1)
            .get();
          let selectedAnalytics = null;
          if (analyticsSnapshot) {
            analyticsSnapshot.forEach((eachAnalytics) => {
              selectedAnalytics = eachAnalytics.data() as DailyAnalyticsModel;
              selectedAnalytics.createdDate = new Date(
                selectedAnalytics.createdDate.seconds * 1000
              );
              selectedDateAnalytics.push(selectedAnalytics);
            });
          }
        })
      );

      selectedDateAnalytics.sort(function (a, b: DailyAnalyticsModel) {
        return b.createdDate.getTime() - a.createdDate.getTime();
      });

      return selectedDateAnalytics;
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
};
